/**
 * Suchfeld der Startseite — zwei Modi
 * ===================================
 *
 * DIESE DATEI RECHNET NICHTS. Sie sammelt einen Namen und übergibt ihn an
 * biomarker.ory-berlin.de. Dort wird zugeordnet, erklärt und vor allem auf
 * Alarmzeichen geprüft. Zwei Orte, die beides täten, laufen auseinander.
 *
 *   Beschwerde  →  ?symptome=Blähungen
 *   Biomarker   →  ?marker=Vitamin D
 *
 * WARUM DIE VORSCHLÄGE VON DER SUBDOMAIN KOMMEN
 * Der Shop kennt 177 Beschwerden, die Subdomain 132. Wer aus der
 * Shop-Liste vorschlägt, schickt Besucher mit „Durchschlafprobleme" auf
 * eine Seite, die das Wort nicht kennt — sie zeigt dann nichts und sagt
 * nicht warum. Deshalb: window.ORY_SUB aus subdomain-listen.js.
 *
 * DIE ANZEIGESCHICHT
 * Sichtbar steht das Wort des Entwurfs, gesucht wird, was Treffer hat.
 * Am 11.08.2026 mit `findBiomarker` der Subdomain gemessen:
 *
 *     angezeigt        trifft
 *     Müdigkeit        Erschöpfung
 *     Hautbild         Hautprobleme
 *     Darmflora        Mikrobiom & Darmflora
 *
 * Zwei Chips des Entwurfs mussten dafür weichen: „Zonulin" trifft
 * „Mikrobiom & Darmflora", „Ferritin" trifft „Selen" — beides über
 * Aliase, nicht über den Namen. Ein Chip, der etwas anderes öffnet als
 * er verspricht, ist schlechter als ein anderer Chip.
 */
(function () {
  'use strict';

  var ZIEL = 'https://biomarker.ory-berlin.de/';
  var MAX_LISTE = 6;

  document.querySelectorAll('[data-suche]').forEach(function (wurzel) {
    var feld    = wurzel.querySelector('[data-suche-feld]');
    var knopf   = wurzel.querySelector('[data-suche-knopf]');
    var chips   = wurzel.querySelector('[data-suche-chips]');
    var meldung = wurzel.querySelector('[data-suche-meldung]');
    var huelle  = wurzel.querySelector('[data-suche-huelle]');
    if (!feld || !huelle) return;

    var D = window.ORY_SUB || { beschwerden: [], marker: [] };
    var modus = 'beschwerde';
    var liste = null;
    var zeiger = -1;

    /** Zwei Schreibformen je Wort — auf dem Handy tippt niemand Umlaute.
     *  „blahungen" und „blaehungen" müssen beide „Blähungen" finden. */
    function formen(s) {
      var t = String(s).toLowerCase().replace(/ß/g, 'ss');
      return [
        t.replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u'),
        t.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue'),
      ];
    }
    function quelle() { return modus === 'beschwerde' ? D.beschwerden : D.marker; }

    function el(tag, klasse, text) {
      var n = document.createElement(tag);
      if (klasse) n.className = klasse;
      if (text != null) n.textContent = text;
      return n;
    }
    function melde(text) {
      if (!meldung) return;
      meldung.textContent = text || '';
      meldung.hidden = !text;
    }

    // ── Vorschläge ───────────────────────────────────────────────────────

    function passend(eingabe) {
      var e = formen(eingabe);
      if (e[0].length < 2) return [];
      var vorn = [], drin = [], q = quelle();
      for (var i = 0; i < q.length; i++) {
        var n = formen(q[i]), p = -1;
        for (var a = 0; a < 2; a++) for (var b = 0; b < 2; b++) {
          var x = n[a].indexOf(e[b]);
          if (x !== -1 && (p === -1 || x < p)) p = x;
        }
        if (p === 0) vorn.push(q[i]); else if (p > 0) drin.push(q[i]);
        if (vorn.length >= MAX_LISTE) break;
      }
      return vorn.concat(drin).slice(0, MAX_LISTE);
    }

    function listeZu() {
      if (liste) { liste.remove(); liste = null; }
      zeiger = -1;
      feld.setAttribute('aria-expanded', 'false');
      feld.removeAttribute('aria-activedescendant');
    }

    function listeAuf(treffer) {
      listeZu();
      if (!treffer.length) return;
      liste = el('ul', 'sus__liste');
      liste.id = feld.id + '-liste';
      liste.setAttribute('role', 'listbox');
      treffer.forEach(function (name, i) {
        var li = el('li', 'sus__treffer', name);
        li.id = liste.id + '-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        // mousedown, nicht click: Das Feld verliert sonst vorher den Fokus.
        li.addEventListener('mousedown', function (ev) { ev.preventDefault(); los(name); });
        liste.appendChild(li);
      });
      huelle.appendChild(liste);
      feld.setAttribute('aria-expanded', 'true');
    }

    function markiere(i) {
      if (!liste) return;
      var e = liste.children;
      zeiger = (i + e.length) % e.length;
      for (var n = 0; n < e.length; n++) {
        var an = n === zeiger;
        e[n].classList.toggle('is-an', an);
        e[n].setAttribute('aria-selected', an ? 'true' : 'false');
      }
      feld.setAttribute('aria-activedescendant', e[zeiger].id);
    }

    // ── Übergabe ─────────────────────────────────────────────────────────

    function aufloesen(text) {
      var e = formen(text.trim()), q = quelle();
      for (var i = 0; i < q.length; i++) {
        var n = formen(q[i]);
        if (n[0] === e[0] || n[0] === e[1] || n[1] === e[0] || n[1] === e[1]) return q[i];
      }
      return null;
    }

    function los(name) {
      var u = new URL(ZIEL);
      u.searchParams.set(modus === 'beschwerde' ? 'symptome' : 'marker', name);
      window.location.href = u.toString();
    }

    function abschicken() {
      var roh = feld.value.trim();
      if (!roh) { melde(feld.dataset.leer || 'Gib eine Beschwerde oder einen Wert ein.'); feld.focus(); return; }
      if (liste && zeiger >= 0) { los(liste.children[zeiger].textContent); return; }
      var treffer = aufloesen(roh);
      if (treffer) { los(treffer); return; }
      var vorschlag = passend(roh);
      if (vorschlag.length === 1) { los(vorschlag[0]); return; }
      melde('„' + roh + '" kennen wir nicht. Tipp die ersten Buchstaben und wähle aus der Liste.');
    }

    // ── Modus ────────────────────────────────────────────────────────────

    function setzeModus(neu) {
      modus = neu;
      wurzel.querySelectorAll('[data-suche-modus]').forEach(function (t) {
        var an = t.dataset.sucheModus === neu;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.classList.toggle('is-an', an);
      });
      // Auswahl leeren — sonst steht eine Beschwerde im Biomarker-Modus.
      feld.value = '';
      feld.placeholder = feld.dataset['platzhalter' + (neu === 'beschwerde' ? 'A' : 'B')] || '';
      listeZu(); melde('');
      chips.querySelectorAll('[data-chip-modus]').forEach(function (c) {
        c.hidden = c.dataset.chipModus !== neu;
      });
      feld.focus();
    }

    // ── Ereignisse ───────────────────────────────────────────────────────

    wurzel.querySelectorAll('[data-suche-modus]').forEach(function (t) {
      t.addEventListener('click', function () { setzeModus(t.dataset.sucheModus); });
    });
    chips.querySelectorAll('[data-chip-wert]').forEach(function (c) {
      c.addEventListener('click', function () { los(c.dataset.chipWert); });
    });
    if (knopf) knopf.addEventListener('click', abschicken);

    feld.addEventListener('input', function () { melde(''); listeAuf(passend(feld.value.trim())); });
    feld.addEventListener('blur', function () { window.setTimeout(listeZu, 120); });
    feld.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' && liste) { ev.preventDefault(); markiere(zeiger + 1); return; }
      if (ev.key === 'ArrowUp' && liste)   { ev.preventDefault(); markiere(zeiger - 1); return; }
      if (ev.key === 'Escape') { listeZu(); return; }
      if (ev.key === 'Enter')  { ev.preventDefault(); abschicken(); }
    });

    setzeModus('beschwerde');
  });
})();
